import React, { Suspense } from 'react';
import Header from './OCPHeader';
import { Spinner } from '@scale/scaleui';
import { useOCPStore } from '../hooks/useOCPStore';
import { twMerge } from 'tailwind-merge';

interface OCPLayoutProps {
  children: React.ReactNode;
}

const OCPLayout: React.FC<OCPLayoutProps> = ({ children }) => {
  const { sidebarOpen } = useOCPStore(state => ({
    sidebarOpen: state.sidebarOpen,
  }));

  return (
    <div className="scaleui scale-theme scale-tailwind">
      <div className="grow overflow-auto flex flex-col">
        <div className="h-full grow flex flex-row">
          <div className="grow flex overflow-auto flex-col">
            <Suspense fallback={<Spinner size="lg" />}>
              <div
                className={twMerge(
                  'flex flex-col flex-1 h-full transition-all',
                  sidebarOpen ? 'pl-[25%]' : 'pl-0',
                )}
              >
                <Header />
                <div className="flex h-full">{children}</div>
              </div>
            </Suspense>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OCPLayout;
